var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDragEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_1634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.4905V16.303H5.0625L13.3575 8.00802L10.545 5.19552L2.25 13.4905ZM15.5325 5.83302C15.825 5.54052 15.825 5.06802 15.5325 4.77552L13.7775 3.02052C13.485 2.72802 13.0125 2.72802 12.72 3.02052L11.3475 4.39302L14.16 7.20552L15.5325 5.83302Z",
    fill: "#343F40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_1634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.553009)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragEdit);
export default __webpack_public_path__ + "static/media/icon-drag-edit.f373fe02547c9ec77d4133e559ef2937.svg";
export { ForwardRef as ReactComponent };